import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../i18n";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        onClick={() => setOpen(!open)}
        aria-label={`Idioma: ${current.name}`}
        style={{
          background: "none",
          border: "1px solid rgba(92,224,190,0.15)",
          borderRadius: 6,
          padding: "4px 10px",
          fontFamily: "var(--font-body)",
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.05em",
          color: "var(--color-accent)",
          cursor: "pointer",
          transition: "background 0.2s",
        }}
        onMouseEnter={(e) => (e.target.style.background = "rgba(92,224,190,0.06)")}
        onMouseLeave={(e) => (e.target.style.background = "none")}
      >
        {current.label}
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            right: 0,
            background: "rgba(12,12,20,0.97)",
            border: "1px solid rgba(92,224,190,0.12)",
            borderRadius: 8,
            padding: 4,
            minWidth: 130,
            backdropFilter: "blur(16px)",
            boxShadow: "0 12px 32px rgba(0,0,0,0.4)",
            zIndex: 200,
          }}
        >
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                i18n.changeLanguage(lang.code);
                setOpen(false);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                width: "100%",
                padding: "8px 12px",
                border: "none",
                borderRadius: 6,
                background:
                  lang.code === i18n.language
                    ? "rgba(92,224,190,0.1)"
                    : "transparent",
                fontFamily: "var(--font-body)",
                fontSize: 12,
                color:
                  lang.code === i18n.language
                    ? "var(--color-accent)"
                    : "var(--text-subtle)",
                cursor: "pointer",
                textAlign: "left",
                transition: "background 0.15s",
              }}
              onMouseEnter={(e) => {
                if (lang.code !== i18n.language)
                  e.currentTarget.style.background = "rgba(92,224,190,0.05)";
              }}
              onMouseLeave={(e) => {
                if (lang.code !== i18n.language)
                  e.currentTarget.style.background = "transparent";
              }}
            >
              <span style={{ fontWeight: 700, minWidth: 22 }}>{lang.label}</span>
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
